(() => {
  if (window.athFinalReady) return;
  window.athFinalReady = true;
  const openers = new WeakMap();
  document.addEventListener('click', event => {
    const launcher = event.target.closest('[data-fit-launch]');
    if (launcher) {
      const dialog = document.getElementById(launcher.dataset.fitLaunch);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      openers.set(dialog, launcher);
      dialog.showModal();
      document.documentElement.classList.add('ath-fit-open');
    }
    const close = event.target.closest('[data-fit-close]');
    if (close) close.closest('dialog').close();
    if (event.target.matches('dialog.ath-fit-dialog')) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
  });
  document.addEventListener('close', event => {
    if (!event.target.matches('.ath-fit-dialog')) return;
    document.documentElement.classList.remove('ath-fit-open');
    openers.get(event.target)?.focus();
  }, true);
})();
